"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _dist = require("package_ui_ihm/dist");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /**
* Nom : batchList.js
* Description : Ce fichier contient la définition de la page batchList 
*               Cette page listera les batches (page en construction)
* Date de création : 30 septembre 2025
*/ /* CSS et assets */ // None
/* Bibliothèques et composants */ /* Hook */ /**
* BatchList : affiche la page qui liste les batches
*
* Type : page 
*
* Parametres : 
*  None
*/
function BatchList() {
  // Define useState hooks
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setDataLoading = _useState2[1];

  // Define useContext hooks
  var _useAuth = (0, _dist.useAuth)(),
    authStatus = _useAuth.authStatus,
    authToken = _useAuth.authToken,
    currentUser = _useAuth.currentUser;
  var _useApi = (0, _dist.useApi)(),
    path = _useApi.path,
    applicationName = _useApi.applicationName;

  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Define useEffect hooks
  (0, _react.useEffect)(function () {
    if (authStatus === 200) {
      setDataLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render component
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [applicationName === "BOXILUMIX" ? currentUser && (currentUser["role_name"] === "AT_ADMIN" || currentUser["role_name"] === "AT_SUPPORT") ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXILUMIX"
    }) : null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.CompanyBar, {
      name_app: "BOXIBRAIN"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.TabC, {
      tabNumber: 3
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: screenWidth > 650 ? 'App' : 'App-ss',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dist.Container, {
        children: "Page Batchs en construction"
      })
    })]
  });
}
var _default = exports["default"] = BatchList;